// extracted by mini-css-extract-plugin
export default {"test":"HomePage_test__p9Ie2","navigate":"HomePage_navigate__9vLUE","homePage_wrap":"HomePage_homePage_wrap__oDugW"};